import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from 'app/shared/app-features/models/features.enum';

@Injectable()
export class OrderListIconActionsMenuFeature implements IFlagFeature {
  name = Features.ORDER_LIST_ICON_ACTIONS_MENU;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
